// extracted by mini-css-extract-plugin
export default {"backdrop":"modals_backdrop__HhUot","modal":"modals_modal__qxlRS","popup":"modals_popup__JxhU0"};